var render = function render(){
  var _vm$$refs$menu;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('nav-menu', _vm._g(_vm._b({
    ref: "menu",
    attrs: {
      "name": _vm.name,
      "icon": _vm.icon,
      "value": _vm.value
    },
    on: {
      "update:value": function ($event) {
        _vm.value = $event;
      }
    }
  }, 'nav-menu', _vm.$attrs, false), _vm.$listeners), [(_vm$$refs$menu = _vm.$refs.menu) !== null && _vm$$refs$menu !== void 0 && _vm$$refs$menu.isLoaded && _vm.value ? _c('div', {
    staticStyle: {
      "width": "360px",
      "min-width": "min(100%, 360px)",
      "max-width": "100%"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-x": "",
      "right": "",
      "max-width": "320px",
      "value": !!_vm.submenu.child,
      "activator": _vm.submenu.activator
    },
    on: {
      "input": function (v) {
        return v || _vm.closeSubmenu();
      }
    }
  }, [_vm.submenu.child ? _c('v-list', {
    staticClass: "nav-menu-content pb-4",
    nativeOn: {
      "mouseenter": function ($event) {
        return _vm.cancelCloseSubmenu.apply(null, arguments);
      },
      "mouseleave": function ($event) {
        return _vm.scheduleCloseSubmenu.apply(null, arguments);
      }
    }
  }, [_c('v-list-item', {
    staticClass: "li-pop ec-dark-blue--text mb-4",
    attrs: {
      "exact": "",
      "to": {
        name: 'catalog',
        params: {
          path: _vm.submenu.child.getPath([_vm.fragment])
        }
      }
    }
  }, [_c('div'), _c('div', {
    staticClass: "ml-n6 design-stack-title font-weight-bold"
  }, [_vm._v("Search all " + _vm._s(_vm.submenu.child.title))]), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _vm._l(_vm.submenu.child.featuredStatic, function (child) {
    return _c('v-list-item', {
      key: 'nested-' + child.fragment,
      staticClass: "li-pop design-stack ec-dark-blue--text pl-4",
      attrs: {
        "exact": "",
        "to": {
          name: 'catalog',
          params: {
            path: child.getPath([_vm.fragment])
          }
        }
      }
    }, [_c('div', {
      staticClass: "design-stack-preview"
    }, _vm._l([2, 1, 0], function (i) {
      return _c('catalog-preview-eager', {
        key: i,
        staticClass: "white",
        attrs: {
          "design": child.preview[i]
        }
      });
    }), 1), _c('div', {
      staticClass: "design-stack-title"
    }, [_c('div', [_c('div', {
      staticClass: "first-letter-uppercase"
    }, [_vm._v(_vm._s(_vm.stripSuffix(child.title)))])]), _c('div', {
      staticClass: "text--label-active"
    }, [_vm._v(_vm._s(_vm._f("dateRange")(child.seasonal)))])]), _c('v-icon', {
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiChevronRight)
      }
    })], 1);
  })], 2) : _vm._e()], 1), _c('v-list', {
    staticClass: "transparent",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    staticClass: "mb-6 li-pop ec-dark-blue--text font-weight-bold",
    attrs: {
      "exact": "",
      "to": {
        name: 'catalog',
        params: {
          path: [_vm.fragment]
        },
        query: {
          autofocus: 1
        }
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMagnify)
    }
  }), _c('div', [_vm._v("Search all " + _vm._s(_vm.name.split('/')[0].trim().toLowerCase()))]), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _vm._l(_vm.featured, function (child) {
    return _c('v-list-item', {
      key: child.fragment,
      staticClass: "li-pop design-stack ec-dark-blue--text",
      class: {
        seasonal: child.seasonalScore > 0
      },
      attrs: {
        "exact": "",
        "to": {
          name: 'catalog',
          params: {
            path: child.getPath([_vm.fragment])
          }
        }
      },
      nativeOn: {
        "mouseenter": function ($event) {
          !_vm.isRight && _vm.openSubmenu(child, $event.currentTarget);
        },
        "mouseleave": function ($event) {
          !_vm.isRight && _vm.scheduleCloseSubmenu();
        }
      }
    }, [_c('div', {
      staticClass: "design-stack-preview"
    }, _vm._l([2, 1, 0], function (i) {
      return _c('catalog-preview-eager', {
        key: 'featured-' + i,
        staticClass: "white",
        attrs: {
          "design": _vm.canLoadHidden || !i ? child.preview[i] : null
        },
        on: {
          "loaded": function ($event) {
            _vm.nLoaded++;
          }
        }
      });
    }), 1), _c('div', {
      staticClass: "design-stack-title"
    }, [_c('div', [_c('div', {
      staticClass: "first-letter-uppercase"
    }, [_vm._v(_vm._s(_vm.stripSuffix(child.title)))])]), _c('div', {
      staticClass: "text--label-active"
    }, [_vm._v(_vm._s(_vm._f("dateRange")(child.seasonal)))])]), _c('v-icon', {
      staticClass: "d-none-no-hover",
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(!_vm.isRight && child.children.length ? _vm.mdiMenuRight : _vm.mdiChevronRight)
      }
    }), _c('v-icon', {
      staticClass: "d-none-hover",
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiChevronRight)
      }
    })], 1);
  }), _c('v-list-item', {
    staticClass: "li-pop ec-dark-blue--text",
    attrs: {
      "exact": "",
      "to": {
        name: 'catalog-categories',
        params: {
          type: _vm.fragment
        }
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiDotsHorizontal)
    }
  }), _c('div', {
    staticClass: "design-stack-title"
  }, [_vm._v("More categories")]), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('v-list-item', {
    staticClass: "mt-6 mb-4 li-pop design-stack ec-dark-blue--text",
    attrs: {
      "exact": "",
      "to": {
        name: 'catalog',
        params: {
          path: [_vm.fragment, 'design-your-own']
        }
      }
    }
  }, [_c('div', {
    staticClass: "design-stack-preview"
  }, _vm._l([2, 1, 0], function (i) {
    return _c('catalog-preview-eager', {
      key: 'custom-' + i,
      staticClass: "white",
      attrs: {
        "design": _vm.canLoadHidden || !i ? _vm.DESIGN_YOUR_OWN_PREVIEW[i] : null
      },
      on: {
        "loaded": function ($event) {
          _vm.nLoaded++;
        }
      }
    });
  }), 1), _c('div', {
    staticClass: "design-stack-title"
  }, [_vm._v("Design your own")]), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 2)], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }